import { render } from "./SeStdTaxForm1120.vue?vue&type=template&id=5fc4ce9d"
import script from "./SeStdTaxForm1120.vue?vue&type=script&lang=js"
export * from "./SeStdTaxForm1120.vue?vue&type=script&lang=js"

import "./SeStdTaxForm1120.vue?vue&type=style&index=0&id=5fc4ce9d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__